import { gql } from 'graphql-request'

export const GET_WRITER_SALES_ANALYTICS_DETAIL = gql`
  query GetWriterSalesAnalyticsDetail(
    $getWriterSalesAnalyticsDetailInput: GetWriterSalesAnalyticsDetailInput!
  ) {
    getWriterSalesAnalyticsDetail(
      getWriterSalesAnalyticsDetailInput: $getWriterSalesAnalyticsDetailInput
    ) {
      tableData {
        bookTitle
        characterName
        total
      }
      graphData {
        value
        date
      }
      graphType
    }
  }
`
